const getLatLng = (item) => ({
  lat: parseFloat(item.latitude),
  lng: parseFloat(item.longitude),
});

export default getLatLng;
